module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_07.3d7d6ad1.png";